<textarea id="report-summary-text-input"
          class="interpretation-summary-text"
          rows="7"
          placeholder="Type interpretation summary here"
          maxlength="30000"
          (change)="updateSummaryText($event)"
          [(ngModel)]="payload.text">
</textarea>
